import { useCallback } from 'react';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/folders/{id}/user_access_folder_participations', {
  only: ['create', 'update', 'delete']
});
const useDeleteUserAccessFolderParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const deleteParticipation = serviceMethods.useDelete({
    callback: useCallback(async (selectedUserAccess, participation, folderId) => {
      await api.delete(folderId, participation.id);
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_folder_participations = userAccessInClaimGroup.user_access_folder_participations.filter(existingParticipation => existingParticipation.id !== participation.id);
      setClaimGroup({
        ...claimGroup
      });
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return deleteParticipation;
};
const useCreateUserAccessFolderParticipationFromClaimGroup = (claimGroup, setClaimGroup, setLoading) => {
  const createParticipation = serviceMethods.useCreate({
    callback: useCallback(async (selectedUserAccess, folderId) => {
      const newParticipation = await api.create(folderId, {
        user_access_id: selectedUserAccess.id
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_folder_participations ||= [];
      userAccessInClaimGroup.user_access_folder_participations.push(newParticipation);
      setClaimGroup({
        ...claimGroup
      });
      return newParticipation;
    }, [claimGroup, setClaimGroup]),
    setLoading
  });
  return createParticipation;
};
const useUpdate = (claimGroup, setClaimGroup) => {
  const update = serviceMethods.useUpdate({
    callback: useCallback(async _ref => {
      let {
        user_access_folder_participation
      } = _ref;
      const updated = await api.update(user_access_folder_participation.folder_id, user_access_folder_participation.id, {
        user_access_folder_participation
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === updated.user_access_id);
      const index = userAccessInClaimGroup.user_access_folder_participations.findIndex(participation => participation.id === updated.id);
      userAccessInClaimGroup.user_access_folder_participations[index] = updated;
      setClaimGroup({
        ...claimGroup
      });
      return updated;
    }, [claimGroup, setClaimGroup])
  });
  return update;
};
const userAccessFolderParticipationsService = {
  useDeleteUserAccessFolderParticipationFromClaimGroup,
  useCreateUserAccessFolderParticipationFromClaimGroup,
  useUpdate
};
export default userAccessFolderParticipationsService;